import React, { useEffect } from 'react';

import { View, Map } from 'ol';
import { MousePosition, ScaleLine, defaults } from 'ol/control';
import { createStringXY } from 'ol/coordinate';

import { useMap } from 'hooks/useMap';
import { MapBlock } from './styles';

export interface IMap {
  center: number[];
  children: React.ReactNode;
  zoom: number;
}

export function MapComponent({ center, children, zoom }: IMap) {
  const { map, setMap, mapRef } = useMap();

  const mousePosition = new MousePosition({
    coordinateFormat: createStringXY(4),
    projection: 'EPSG:4326',
  });

  useEffect(() => {
    const options = {
      target: 'map',
      view: new View({ zoom, center, maxZoom: 17 }),
      controls: defaults().extend([new ScaleLine(), mousePosition]),
    };

    const mapObject = new Map(options);

    mapObject.setTarget(mapRef.current as HTMLDivElement);

    setMap(mapObject);

    return () => mapObject.setTarget(undefined);
  }, []);

  useEffect(() => {
    if (!map) return;
    map.getView().setZoom(zoom);
  }, [zoom]);

  useEffect(() => {
    if (!map) return;
    map.getView().setCenter(center);
  }, [center]);
  
  return <MapBlock ref={mapRef}>{children}</MapBlock>;
}
